
import React from 'react'
import withBodyScrollDisabled from './withBodyScrollDisabled'

export default withBodyScrollDisabled(() => <noscript />)



// WEBPACK FOOTER //
// ./ui/DisableBodyScroll.js